import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import MainLayout from "./layout/MainLayout";
import DashboardLayout from "./layout/DashboardLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserProvider } from "./contexts/UserContext";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VenueDetails from "./pages/VenueDetails";
import Profile from "./pages/Profile";
import EditVenues from "./pages/EditVenues";
import Dashboard from "./pages/Dashboard";
import Staff from "./pages/Staff";
import InvoicePdf from "./pages/invoicePdf";
import Appointment from "./pages/Appointment";
import Clients from "./pages/clients/Clients";
import Community from "./pages/clients/Community";
import PromoCode from "./pages/PromoCode";
import CLientsInfo from "./pages/clients/ClientsInfo";
import Invoices from "./pages/finance/Invoices";
import Expenses from "./pages/finance/Expenses";
import Reports from "./pages/finance/Reports";
import Specialities from "./pages/settings/Specialities";
import Services from "./pages/settings/Services";
import Currencies from "./pages/settings/Currencies";
import Units from "./pages/settings/Units";
import UserNotifications from "./pages/UserNotifications";
import Advanced from "./pages/settings/Advanced";
import { useInactivityTimeout } from "./hooks/useInactivityTimeout";
import Banners from "./pages/Banners";
import AdminData from "./pages/AdminData";
import AdminInvoices from "./pages/AdminInvoices";
import AdminExpenses from "./pages/AdminExpenses";
import AdminReports from "./pages/AdminReports";

const AppContent: React.FC = () => {
  useInactivityTimeout();
  
  return (
    <>
      <ToastContainer position="top-right" />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Protected routes with MainLayout */}
        <Route
          element={
            <ProtectedRoute>
              <MainLayout>
                <Outlet />
              </MainLayout>
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/venue-details" element={<VenueDetails />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/edit-venues" element={<EditVenues />} />
          <Route path="/all-data" element={<AdminData />} />
          <Route path="/all-data/invoices" element={<AdminInvoices />} />
          <Route path="/all-data/expenses" element={<AdminExpenses />} />
          <Route path="/all-data/reports" element={<AdminReports />} />
        </Route>

        {/* Protected Dashboard routes */}
        <Route
          path="/dashboard/:branchId/*"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }>
          <Route index element={<Dashboard />} />
          <Route path="overview" element={<Dashboard />} />
          <Route path="staff" element={<Staff />} />
          <Route path="appointment" element={<Appointment />} />
          <Route path="settings" element={<Dashboard />} />
          <Route path="banners" element={<Banners />} />
          <Route path="invoicepdf/:id" element={<InvoicePdf />} />
          <Route path="userNotifications" element={<UserNotifications />} />
          <Route path="clients/clients" element={<Clients />} />
          <Route path="clients/community" element={<Community />} />
          <Route path="promocode" element={<PromoCode />} />
          <Route path="clients/info" element={<CLientsInfo />} />
          <Route path="finance/invoices" element={<Invoices />} />
          <Route path="finance/expenses" element={<Expenses />} />
          <Route path="finance/reports" element={<Reports />} />
          <Route path="settings/specialities" element={<Specialities />} />
          <Route path="settings/services" element={<Services />} />
          <Route path="settings/currencies" element={<Currencies />} />
          <Route path="settings/units" element={<Units />} />
          <Route path="settings/advanced" element={<Advanced />} />
        </Route>
      </Routes>
    </>
  );
};

const App: React.FC = () => (
  <Router>
    <UserProvider>
      <AppContent />
    </UserProvider>
  </Router>
);

export default App;
